import CategoryService from '@/services/CategoryService'

const categoriesModule = {
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    categories: [],
    armedField: null
  },
  actions: {
    getCategories: async ({ commit, state }) => {
      return CategoryService.getCategories(state.pageSize, state.page)
        .then((data) => {
          commit('SET_CATEGORIES', { categories: data.categories })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    deleteCategory: async ({ dispatch }, categoryId) => {
      await CategoryService.deleteCategory(categoryId)
      await dispatch('getCategories')
    },
    setPage: ({ dispatch, commit }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getCategories')
    },
    armField: ({ commit }, field) => {
      commit('SET_ARMED_FIELD', { field })
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    },
    armedField: (state) => state.armedField
  },
  mutations: {
    SET_CATEGORIES: (state, { categories }) => {
      state.categories = categories
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    },
    SET_ARMED_FIELD: (state, { field }) => {
      state.armedField = field
    }
  }
}

export default categoriesModule
